import {
  Component,
  OnInit,
  inject,
  computed,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { IosInstallInstructions } from '../ios-install-instructions/ios-install-instructions';
import { PwaInstallService } from '../../services/pwa-install.service';

@Component({
  selector: 'app-pwa-install-banner',
  imports: [CommonModule, TranslatePipe, IosInstallInstructions],
  templateUrl: './pwa-install-banner.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pwa-install-banner.scss',
})
export class PwaInstallBanner implements OnInit {
  private pwaService = inject(PwaInstallService);
  private isDismissed = signal(false);
  private isEdgeDismissed = signal(false);
  private isIosBrowserDismissed = signal(false);

  isVisible = computed(
    () =>
      this.pwaService.canInstall() &&
      this.pwaService.shouldShowPrompt() &&
      !this.isDismissed(),
  );

  isEdgeVisible = computed(
    () => this.pwaService.showEdgeBrowserMessage() && !this.isEdgeDismissed(),
  );

  isIosBrowserVisible = computed(
    () =>
      this.pwaService.showIosBrowserMessage() && !this.isIosBrowserDismissed(),
  );

  isIOS = false;
  showIosInstructions = false;

  ngOnInit(): void {
    this.isIOS = this.pwaService.isIOS();
  }

  install(): void {
    if (this.isIOS) {
      this.showIosInstructions = true;
    } else {
      this.pwaService.installPwa();
    }
  }

  openInChrome(): void {
    this.pwaService.openInChrome();
  }

  openInSafari(): void {
    this.pwaService.openInSafari();
  }

  dismissEdgeBanner(): void {
    this.pwaService.dismissEdgeBannerPrompt();
    this.isEdgeDismissed.set(true);
  }

  dismissIosBrowserBanner(): void {
    this.pwaService.dismissIosBrowserBanner();
    this.isIosBrowserDismissed.set(true);
  }

  dismiss(): void {
    this.pwaService.dismissPrompt();
    this.isDismissed.set(true);
  }

  closeInstructions(): void {
    this.showIosInstructions = false;
    this.dismiss();
  }
}
